import { render } from "./Definitions.vue?vue&type=template&id=4a0f6ead&scoped=true"
import script from "./Definitions.vue?vue&type=script&lang=js"
export * from "./Definitions.vue?vue&type=script&lang=js"

import "./Definitions.vue?vue&type=style&index=0&id=4a0f6ead&scoped=true&lang=css"

import exportComponent from "/home/nodeapps/uzb/frontendBuild/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a0f6ead"]])

export default __exports__